<template>
  <div>
    <div v-if="item.video_chapters && item.video_chapters.length">
      <div
          v-for="(chapter, index) in item.video_chapters"
          class="question-chapter video"
          :class="{ big: chapter.category }"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="chapter-remove-icon"
                v-bind="attrs"
                v-on="on"
                :class="{ disabled: removeFromListLoading }"
                @click="
                  removeItemFromSubchapter(
                    chapter,
                    questionTypes.videoQuestions.query,
                    item
                  )
                "
            >
              mdi-close
            </v-icon>
          </template>
          <span>Remove</span>
        </v-tooltip>

        <div class="chapter-name-container">
          <div v-if="chapter.category" class="chapter-name">
            {{ chapter.category.name }} [{{ getDisplayedPlatforms(chapter.category) }}]
          </div>
        </div>

        <div class="subchapter-name-container">
          <div class="subchapter-name">
            {{ chapter.name }} [{{ getDisplayedPlatforms(chapter) }}]
          </div>
        </div>
      </div>
    </div>

    <div v-if="item.theory_chapters && item.theory_chapters.length">
      <div
          v-for="(chapter, index) in item.theory_chapters"
          class="question-chapter theory"
          :class="{ big: chapter.category }"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="chapter-remove-icon"
                v-bind="attrs"
                v-on="on"
                :class="{ disabled: removeFromListLoading }"
                @click="
                  removeItemFromSubchapter(
                    chapter,
                    questionTypes.theoryQuestions.query,
                    item
                  )
                "
            >
              mdi-close
            </v-icon>
          </template>
          <span>Remove</span>
        </v-tooltip>

        <div class="chapter-name-container">
          <div v-if="chapter.category" class="chapter-name">
            {{ chapter.category.name }} [{{ getDisplayedPlatforms(chapter.category) }}]
          </div>
        </div>

        <div class="subchapter-name-container">
          <div class="subchapter-name">
            {{ chapter.name }} [{{ getDisplayedPlatforms(chapter) }}]
          </div>
        </div>
      </div>
    </div>

    <div v-if="item.question_chapters && item.question_chapters.length">
      <div
          v-for="(chapter, index) in item.question_chapters"
          class="question-chapter question"
          :class="{ big: chapter.category }"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="chapter-remove-icon"
                v-bind="attrs"
                v-on="on"
                :class="{ disabled: removeFromListLoading }"
                @click="
                  removeItemFromSubchapter(
                    chapter,
                    questionTypes.practiceQuestions.query,
                    item
                  )
                "
            >
              mdi-close
            </v-icon>
          </template>
          <span>Remove</span>
        </v-tooltip>

        <div class="chapter-name-container">
          <div v-if="chapter.category" class="chapter-name">
            {{ chapter.category.name }} [{{ getDisplayedPlatforms(chapter.category) }}]
          </div>
        </div>

        <div class="subchapter-name-container">
          <div class="subchapter-name">
            {{ chapter.name }} [{{ getDisplayedPlatforms(chapter) }}]
          </div>
        </div>
      </div>
    </div>

    <template v-for="exam in exams">
      <template v-for="examType in examTypes">
        <template v-for="examQuestion in exam[examType.query]">
          <div
              v-if="examQuestion.id === item.id"
              class="big question-chapter exam"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    class="chapter-remove-icon"
                    v-bind="attrs"
                    v-on="on"
                    :class="{ disabled: removeFromListLoading }"
                    @click="removeExamFromSubchapter(exam, examType.query, item)"
                >
                  mdi-close
                </v-icon>
              </template>
              <span>Remove</span>
            </v-tooltip>

            <div class="chapter-name-container">
              <div class="chapter-name">
                {{ exam.name }} [{{ getDisplayedPlatforms(exam) }}]
              </div>
            </div>

            <div class="subchapter-name-container">
              <div class="subchapter-name">{{ examType.title }}</div>
            </div>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    exams: {
      type: Array,
      default: () => [],
    },
    examTypes: {
      type: Array,
      default: () => [],
    },
    removeFromListLoading: {
      type: Boolean,
      default: false,
    },
    questionTypes: {
      type: Object,
      required: true,
    },
    getDisplayedPlatforms: {
      type: Function,
      required: true,
    },
    removeItemFromSubchapter: {
      type: Function,
      required: true,
    },
    removeExamFromSubchapter: {
      type: Function,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.question-chapter {
  margin-top: 2px;
  border-radius: 4px;
  padding: 4px;
  font-weight: 500;
  font-size: 10px;
  position: relative;

  &:hover {
    .chapter-remove-icon {
      visibility: visible;
      opacity: 1;
    }
  }

  &.video {
    background-color: $success-check-color;

    .chapter-remove-icon {
      background-color: $success-check-color;
    }
  }
  &.theory {
    background-color: $warning-color;

    .chapter-remove-icon {
      background-color: $warning-color;
    }
  }
  &.question {
    background-color: $primary-color;

    .chapter-remove-icon {
      background-color: $primary-color;
    }
  }
  &.exam {
    background-color: $orange-color;

    .chapter-remove-icon {
      background-color: $orange-color;
    }
  }

  &.big {
    padding-top: 2px;
  }

  .chapter-name-container {
    display: table;
    table-layout: fixed;
    width: 100%;

    .chapter-name {
      color: $app-bg-color;
      padding-bottom: 2px;
      display: table-cell;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .chapter-remove-icon {
    position: absolute;
    top: 0;
    right: 0;
    color: $app-bg-color;
    font-size: 18px;
    cursor: pointer;
    border-radius: 4px;
    opacity: 0;
    visibility: hidden;

    &.disabled {
      opacity: 0.6;
      cursor: auto;
    }
  }

  .subchapter-name-container {
    background-color: $app-bg-color;
    border-radius: 4px;
    padding: 2px 4px;
    display: table;
    table-layout: fixed;
    width: 100%;

    .subchapter-name {
      color: $title-second;
      display: table-cell;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .span-container {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 40%;
    display: inline-block;
  }
  .span-divider {
    display: inline-block;
  }
  span:not(.v-tooltip) {
    white-space: nowrap;
    display: inline-block;
  }
}
</style>
